<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <event-filter/>
    </div>
    <div class="aco-details-box">
      <event-list/>
    </div>
  </div>
</template>

<script>
  import EventFilter from './EventFilter'
  import EventList from './EventList'

  export default {
    components: {
      eventFilter: EventFilter,
      eventList: EventList
    }
  }
</script>
